/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

class LocalizationSuggestions extends HTMLElement {
  connectedCallback() {
    // Skip when there is no localization dialog
    const localizationDialog = document.querySelector('dialog#localization-dialog');
    if (!localizationDialog) return;

    // Skip when in shopify design mode
    if (Shopify.designMode) return;

    // Handle the form submit and fetch the geo location suggestions
    this.handleFormSubmit();
    this.handleGeoLocation();

    // Also set a cookie when the dialog is closed or ignored
    this.unsubscribeClosed = subscribe('dialog:closed:localization-dialog', () => {
      console.log('dialog:closed:localization-dialog');
      api.set('localization_suggested_country_code', this.dataset.currentCountryCode, {
        expires: 14,
      });
    });
  }

  disconnectedCallback() {
    this.unsubscribeClosed();
  }

  setCookie() {
    api.set(
      'localization_suggested_country_code',
      this.querySelector(`select[name="country_code"]`).value,
      { expires: 14 }
    );
  }

  handleFormSubmit() {
    // Save the country code when the form is submitted
    this.querySelector('form')?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.setCookie();
      event.target.submit();
    });
  }

  async fetchGeoLocationSuggestions() {
    // Fetch the geo location suggestions
    this.data = await fetch(
      `${window.location.origin}/browsing_context_suggestions.json` +
        `?country[enabled]=true` +
        `&country[exclude]=${window.Shopify.country}` +
        `&language[enabled]=true` +
        `&language[exclude]=${window.Shopify.language}`
    ).then((r) => r.json());

    const { handle: suggestedCountryCode } = this.data?.detected_values?.country || '';

    return suggestedCountryCode;
  }

  async handleGeoLocation() {
    // Get the country code from the cookie or fetch based on the geo location suggestions
    let suggestedCountryCode = api.get('localization_suggested_country_code');
    if (!suggestedCountryCode) {
      suggestedCountryCode = await this.fetchGeoLocationSuggestions();
    }
    // Read the current country code from the liquid rendered form
    const currentCountryCode = this.dataset.currentCountryCode;

    // Check if the current country is correct is matching
    if (suggestedCountryCode === currentCountryCode) return;

    // Open the dialog, and suggest the new country option
    publish('dialog:open', { dialogId: 'localization-dialog' });
    this.querySelector(`button[data-value="${suggestedCountryCode}"]`)?.click();
  }
}

customElements.define('localization-suggestions', LocalizationSuggestions);
